import Swal from "sweetalert2";

export const AlertResultApi = (status: number, message?: string) => {
  if (status === 401) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${status} Unauthorized!`,
    }).then(() => {
      window.history.go(-1);
      return false;
    });
  } else {
    Swal.fire({
      icon: "error",
      title: `Oops... ${status}`,
      text: message || `${status} Something went wrong!`,
    });
  }
};

export const AlertError = (title: string, message: string) => {
  Swal.fire({
    icon: "error",
    title: title,
    text: message,
  });
};

export const AlertSuccess = (title: string, message: string) => {
  Swal.fire(title, message, "success");
};

export const AlertConfrim = (
  title: string,
  text: string,
  callback: () => Promise<void>,
  titleFinished: string,
  testFinished: string
) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes",
  }).then((result) => {
    if (result.isConfirmed) {
      callback().then(() => {
        Swal.fire(titleFinished, testFinished, "success");
      });
    }
  });
};
